import React from "react";

import {
  IconNeoplasms,
  IconInfections,
  IconImmuneSystem,
  IconEndocrineSystem,
  IconNutritionalMetabolic,
  IconMental,
  IconNervousSystem,
  IconCardiovascular,
  IconHemicLymphatic,
  IconCongenitalHereditary,
  IconDigestiveSystem,
  IconRespiratoryTract,
  IconUrogenital,
  IconTAEye,
  IconMusculoskeletal,
  IconSkinConnectiveTissue,
  IconTAWoundsInjuries,
  IconPathologicalConditions,
  IconOtorhinolaryngologic,
  IconChemicallyInduced,
  IconEnvironmentOrigin,
  IconOccupational,
  IconStomatognathic,
  IconTADefault,
} from "../Icons";

type DefaultType = {
  [key: string]: React.ReactNode;
};

export const THERAPEUTIC_AREA_CATEGORY_ICONS = {
  neoplasms: IconNeoplasms,
  infections: IconInfections,
  "immune system diseases": IconImmuneSystem,
  "endocrine system diseases": IconEndocrineSystem,
  "nutritional and metabolic diseases": IconNutritionalMetabolic,
  "mental disorders": IconMental,
  "nervous system diseases": IconNervousSystem,
  "cardiovascular diseases": IconCardiovascular,
  "hemic and lymphatic diseases": IconHemicLymphatic,
  "congenital, hereditary, and neonatal diseases and abnormalities":
    IconCongenitalHereditary,
  "digestive system diseases": IconDigestiveSystem,
  "respiratory tract diseases": IconRespiratoryTract,
  "urogenital diseases": IconUrogenital,
  "eye diseases": IconTAEye,
  "musculoskeletal diseases": IconMusculoskeletal,
  "skin and connective tissue diseases": IconSkinConnectiveTissue,
  "wounds and injuries": IconTAWoundsInjuries,
  "pathological conditions, signs and symptoms": IconPathologicalConditions,
  "otorhinolaryngologic diseases": IconOtorhinolaryngologic,
  "chemically-induced disorders": IconChemicallyInduced,
  "disorders of environmental origin": IconEnvironmentOrigin,
  "occupational diseases": IconOccupational,
  "stomatognathic diseases": IconStomatognathic,
  empty: IconTADefault,
} as const;

export const THERAPEUTIC_AREA_ICON_GROUP: DefaultType = {
  neoplasms: <IconNeoplasms width={16} height={16} />,
  infections: <IconInfections width={16} height={16} />,
  immuneSystem: <IconImmuneSystem width={16} height={16} />,
  endocrineSystem: <IconEndocrineSystem width={16} height={16} />,
  nutritionalMetabolic: <IconNutritionalMetabolic width={16} height={16} />,
  mental: <IconMental width={16} height={16} />,
  nervousSystem: <IconNervousSystem width={16} height={16} />,
  cardiovascular: <IconCardiovascular width={16} height={16} />,
  hemicLymphatic: <IconHemicLymphatic width={16} height={16} />,
  congenitalHereditary: <IconCongenitalHereditary width={16} height={16} />,
  digestiveSystem: <IconDigestiveSystem width={16} height={16} />,
  respiratoryTract: <IconRespiratoryTract width={16} height={16} />,
  urogenital: <IconUrogenital width={16} height={16} />,
  eye: <IconTAEye width={16} height={16} />,
  musculoskeletal: <IconMusculoskeletal width={16} height={16} />,
  skinConnectiveTissue: <IconSkinConnectiveTissue width={16} height={16} />,
  woundsInjuries: <IconTAWoundsInjuries width={16} height={16} />,
  pathologicalConditions: <IconPathologicalConditions width={16} height={16} />,
  otorhinolaryngologic: <IconOtorhinolaryngologic width={16} height={16} />,
  chemicallyInduced: <IconChemicallyInduced width={16} height={16} />,
  environmentOrigin: <IconEnvironmentOrigin width={16} height={16} />,
  occupational: <IconOccupational width={16} height={16} />,
  stomatognathic: <IconStomatognathic width={16} height={16} />,
  empty: <IconTADefault width={16} height={16} />,

  "immune system diseases": <IconImmuneSystem width={16} height={16} />,
  "endocrine system diseases": <IconEndocrineSystem width={16} height={16} />,
  "nutritional and metabolic diseases": (
    <IconNutritionalMetabolic width={16} height={16} />
  ),
  "mental disorders": <IconMental width={16} height={16} />,
  "nervous system diseases": <IconNervousSystem width={16} height={16} />,
  "cardiovascular diseases": <IconCardiovascular width={16} height={16} />,
  "hemic and lymphatic diseases": <IconHemicLymphatic width={16} height={16} />,
  "congenital, hereditary, and neonatal diseases and abnormalities": (
    <IconCongenitalHereditary width={16} height={16} />
  ),
  "digestive system diseases": <IconDigestiveSystem width={16} height={16} />,
  "respiratory tract diseases": <IconRespiratoryTract width={16} height={16} />,
  "urogenital diseases": <IconUrogenital width={16} height={16} />,
  "eye diseases": <IconTAEye width={16} height={16} />,
  "musculoskeletal diseases": <IconMusculoskeletal width={16} height={16} />,
  "skin and connective tissue diseases": (
    <IconSkinConnectiveTissue width={16} height={16} />
  ),
  "wounds and injuries": <IconTAWoundsInjuries width={16} height={16} />,
  "pathological conditions, signs and symptoms": (
    <IconPathologicalConditions width={16} height={16} />
  ),
  "otorhinolaryngologic diseases": (
    <IconOtorhinolaryngologic width={16} height={16} />
  ),
  "chemically-induced disorders": (
    <IconChemicallyInduced width={16} height={16} />
  ),
  "disorders of environmental origin": (
    <IconEnvironmentOrigin width={16} height={16} />
  ),
  "occupational diseases": <IconOccupational width={16} height={16} />,
  "stomatognathic diseases": <IconStomatognathic width={16} height={16} />,
};

type TherapeuticAreaIconListProps = {
  width?: number;
  height?: number;
  color?: string;
};

export const THERAPEUTIC_AREA_ICON_LIST = ({
  width = 16,
  height = 16,
  color = "#515C6C",
}: TherapeuticAreaIconListProps): DefaultType => ({
  neoplasms: <IconNeoplasms width={width} height={height} color={color} />,
  infections: <IconInfections width={width} height={height} color={color} />,
  immuneSystem: (
    <IconImmuneSystem width={width} height={height} color={color} />
  ),
  endocrineSystem: (
    <IconEndocrineSystem width={width} height={height} color={color} />
  ),
  nutritionalMetabolic: (
    <IconNutritionalMetabolic width={width} height={height} color={color} />
  ),
  mental: <IconMental width={width} height={height} color={color} />,
  nervousSystem: (
    <IconNervousSystem width={width} height={height} color={color} />
  ),
  cardiovascular: (
    <IconCardiovascular width={width} height={height} color={color} />
  ),
  hemicLymphatic: (
    <IconHemicLymphatic width={width} height={height} color={color} />
  ),
  congenitalHereditary: (
    <IconCongenitalHereditary width={width} height={height} color={color} />
  ),
  digestiveSystem: (
    <IconDigestiveSystem width={width} height={height} color={color} />
  ),
  respiratoryTract: (
    <IconRespiratoryTract width={width} height={height} color={color} />
  ),
  urogenital: <IconUrogenital width={width} height={height} color={color} />,
  eye: <IconTAEye width={width} height={height} color={color} />,
  musculoskeletal: (
    <IconMusculoskeletal width={width} height={height} color={color} />
  ),
  skinConnectiveTissue: (
    <IconSkinConnectiveTissue width={width} height={height} color={color} />
  ),
  woundsInjuries: (
    <IconTAWoundsInjuries width={width} height={height} color={color} />
  ),
  pathologicalConditions: (
    <IconPathologicalConditions width={width} height={height} color={color} />
  ),
  otorhinolaryngologic: (
    <IconOtorhinolaryngologic width={width} height={height} color={color} />
  ),
  chemicallyInduced: (
    <IconChemicallyInduced width={width} height={height} color={color} />
  ),
  environmentOrigin: (
    <IconEnvironmentOrigin width={width} height={height} color={color} />
  ),
  occupational: (
    <IconOccupational width={width} height={height} color={color} />
  ),
  stomatognathic: (
    <IconStomatognathic width={width} height={height} color={color} />
  ),
  empty: <IconTADefault width={width} height={height} color={color} />,
});
